const RETURN_URL_BASE = "https://pax.invalid";

function isAuthPath(pathname: string): boolean {
  return (
    pathname === "/login" ||
    pathname.startsWith("/login/") ||
    pathname === "/create-account" ||
    pathname === "/api/auth" ||
    pathname.startsWith("/api/auth/")
  );
}

export function safeNextPath(value: string | undefined, fallback = "/"): string {
  if (!value?.startsWith("/") || value.startsWith("//") || value.includes("\\")) return fallback;

  try {
    const url = new URL(value, RETURN_URL_BASE);
    const decodedPath = decodeURIComponent(url.pathname);
    if (
      url.origin !== RETURN_URL_BASE ||
      decodedPath.startsWith("//") ||
      decodedPath.includes("\\") ||
      isAuthPath(new URL(decodedPath, RETURN_URL_BASE).pathname)
    ) {
      return fallback;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
